@if (query.isSuccess() && hasAlerts()) {
  <section class="alerts-bar" aria-label="Important updates">
    <div class="alerts-bar__header">
      <span class="alerts-bar__title">Important Updates!</span>
      <button
        class="alerts-bar__toggle"
        type="button"
        [attr.aria-expanded]="expanded()"
        aria-controls="alerts-bar-content"
        (click)="toggle()">
        {{ expanded() ? 'Hide' : 'Show' }}
      </button>
    </div>

    <div
      id="alerts-bar-content"
      class="alerts-bar__content"
      [class.alerts-bar__content--expanded]="expanded()"
      [attr.aria-hidden]="!expanded()">
      <div class="alerts-bar__content-inner">
        @for (alert of alerts(); track alert.id) {
          <article class="alerts-bar__alert">
            <div class="alerts-bar__icon" aria-hidden="true">
              <i class="fas fa-building"></i>
            </div>
            <div class="alerts-bar__message" [innerHTML]="alert.html"></div>
          </article>
        }
      </div>
    </div>
  </section>
}
